"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class PricingTable extends Parse.Object {
    constructor(attributes) {
        super('PricingTable', attributes);
    }
    /** name of this princing table */
    get name() { return this.get('name'); }
    set name(value) { this.set('name', value); }
    /** pointer to the owner of this pricing table */
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    /** true when this is the default pricing table */
    get default() { return this.get('default'); }
    set default(value) { this.set('default', value); }
    /** id referente a este objeto quando integrado com um gateway externo */
    get externalId() { return this.get('externalId'); }
    set externalId(value) { this.set('externalId', value); }
    get branches() { return this.get('branches'); }
    set branches(value) { this.set('branches', value); }
    get teams() { return this.get('teams'); }
    set teams(value) { this.set('teams', value); }
}
exports.PricingTable = PricingTable;
Parse.Object.registerSubclass('PricingTable', PricingTable);
//# sourceMappingURL=PricingTable.js.map